<template>
  <div class="form-check form-check-inline" v-for="(option,index) in options" :key="index">
    <input
      class="form-check-input"
      type="radio"
      :class="{'is-invalid': invalid}"
      :id="option.id"
      :value="option.value"
      v-model="selectValue"
    >
    <label class="form-check-label" :for="option.id">{{ option.text }}</label>
  </div>
</template>
<script>
export default {
  name: 'RadioButtons',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    invalid: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  computed: {
    selectValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
}
</script>
